import IRequest from "../../IRequest";

export interface IConfiguracoesBancarias {
    reqConfigBancaria: IRequest<TConfiguracaoBancaria>,
    dataConfigBancaria: TConfiguracaoBancaria[]
  }

export type TConfiguracaoBancaria = {
    id: number,
    nome_banco: string
    codigo: string,
    agencia: number,
    agencia_digito: number,
    conta: number,
    conta_digito: number,
    integracao: TIntegracaoBancaria
}

export type TConfigBancariasSemIntegracao = Omit<TConfiguracaoBancaria, 'integracao'>;

export type TIntegracaoBancaria = Record<string, any>;

export const defaultIntegracaoBancaria: TIntegracaoBancaria = {
    id: 0,
    nome: "",
    codigo: "",
    agencia: 0,
    agencia_digito: 0,
    conta: 0,
    conta_digito: 0,
};
